// extracted by mini-css-extract-plugin
module.exports = {"varSpDown3":"0.25rem","varSpDown2":"0.5rem","varSpBase":"1rem","varSpUp1":"1.25rem","varSpUp2":"1.5rem","varSpUp3":"1.75rem","priceFilterContainer":"priceFilterContainer--a06d0"};